exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".offer-point{margin-top:4px;margin-bottom:8px;color:#2a2a2a}.offer-point--unavailable{color:#9fb0b5;text-decoration:line-through}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};